import { useWatch } from 'react-hook-form';

import { useProduct } from '@/entities/product';
import type { FormFields } from '@/entities/purchase-form';

export const useNearbyStoresWithInventory = () => {
    const currentDeliveryMethod = useWatch<FormFields, 'fulfilmentMethod'>({ name: 'fulfilmentMethod' });

    const { product, tailored, isLoading, isError } = useProduct();

    const selectedStoreId = tailored?.variants?.[product?.sku ?? ''].BOPIS?.storeId;
    const inventoryAtSelectedStore = tailored?.variants?.[product?.sku ?? ''].BOPIS?.availableStock;
    const hasAltStoresWithInventory = tailored?.variants?.[product?.sku ?? ''].BOPIS?.altAvailableStock;

    const isBopisSelectionValid = !!(selectedStoreId && inventoryAtSelectedStore);

    const shouldRenderNearbyStoresCTA = !!(
        currentDeliveryMethod === 'bopis' &&
        !isError &&
        !isBopisSelectionValid &&
        hasAltStoresWithInventory
    );

    return { isLoading, isError, shouldRenderNearbyStoresCTA };
};
